





import Vue from 'vue'
import { PropValidator } from 'vue/types/options'  // using "as () => T" seems enough
import { IDevice } from '@/types/model'
import { setInterval } from 'timers'
import { thumb_size_t } from '@/store/modules/pref'
import { reqMan } from '@/singleton'
import { convertToDataUrl } from '@/utils'


interface geometry_size_t {
  width: number
  height: number
}

export default Vue.extend({
  model: {
    prop: 'device'
  },
  props: {
    imageId: {
      type: Number
    },
    thumbSize: {
      type: String,
      default: 'md'
    } as PropValidator<thumb_size_t>,
    /**
     * width and height has higher priority than thumbSize.
     * Don't specify width and height simultaneously.
     */
    width: {
      type: Number,
      default: 0
    },
    /**
     *  width and height has higher priority than thumbSize
     * Don't specify width and height simultaneously.
     */
    height: {
      type: Number,
      defualt: 0
    },
    maxWidth: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    intervalId: -1,
  }),
  computed: {
    rootSize (): geometry_size_t {
      if (this.width) {
        return { width: this.width, height: this.width * 5 / 9 }
      } else if (this.height) {
        return { width: this.height * 9 / 5, height: this.height }
      } else {
        let w = 0
        switch (this.thumbSize) {
          case 'xs': w = 60; break
          case 'sm': w = 90; break
          case 'md': w = 110; break
          case 'lg': w = 150; break
          case 'xl': w = 200; break
        }
        while (this.$state.common.windowSize.width - w < 200) {
          w -= 2
        }
        if (this.maxWidth >= 1 && w > this.maxWidth) {
          w = this.maxWidth
        }
        return { width: w, height: w * 480 / 640 }
      }
    },
    rootStyle (): string {
      const tmp = `width:${this.rootSize.width}px;height:${this.rootSize.height}px;`
      return tmp
    },
    imgUrl (): string {
      const imgInfo = this.$s.$state.device.osd.imgList.find(x => x.id === this.imageId)
      if (!imgInfo) {return ''}
      return imgInfo.fileName
    }
  },
  mounted () {
    if (this.width > 0 && this.height > 0) { console.error(`[To Developer] Don't specify width and width simutaneously`) }
    if (this.imageId === undefined) { console.error('[To Developer] :imageId= is required') }
  },
})
